<nz-spin [nzSpinning]="loading">
  <section class="bg-[#F2F2F2] preview-custom">
    <div class="container">
      <div class="grid grid-cols-1">
        <!-- Banner -->
        <div *ngIf="data?.featured?.image">
          <div class="bg-[#ECF4F7] relative flex flex-col">
            <div
              class="cover-overlay absolute left-0 top-0 z-20 h-[32rem] md:h-[48rem] w-full"></div>
            <img loading="lazy"
              class="absolute object-cover left-0 top-0 z-10 w-full h-[32rem] md:h-[48rem] rounded-t-[20px] rounded-b-[20px] md:rounded-t-[10px] md:rounded-b-[20px]"
              [src]="data?.featured?.image"
              alt="splash header"/>
            <div
              class="relative flex flex-col items-center justify-center z-40 custom-p">
              <ng-container *ngIf="!data?.viewSettings?.isItineraryTitleChecked">
                <div *ngIf="this.data?.title else altTitle" >
                  <h5 style="color: white; font-weight: 400 !important">{{this.data?.title}}</h5>
                </div>
                <ng-template #altTitle>
                  <div class="h-8"></div>
                </ng-template>
              </ng-container>
              <div class="hidden md:block">
                <h3 style="color: white">
                  {{ data?.days.length | number : '2.0' }} {{this.localizationContent?.days}} /
                  {{ data?.days.length - 1 | number : '2.0' }} {{this.localizationContent?.nights}}
                </h3>
              </div>
              <div class="my-3 hidden md:block">
                <hr class="w-60"/>
              </div>
              <div class="hidden md:block">
                <div
                  *ngIf="this.countries.length !== 0"
                  class="flex flex-row mb-2">
                  <div *ngFor="let country of this.countries">
                    <h5
                      style="color: white; font-weight: 400 !important"
                      class="pe-3">
                      {{ country }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-1 mt-[5.5rem] md:mt-[3rem] space-y-[20px] md:space-y-[20px]">
        <div class="p-8 md:p-12 rounded-[20px] bg-white block md:hidden">
          <div *ngIf="this.data?.title && !data?.viewSettings?.isItineraryTitleChecked">
            <p class="font-light">{{this.data?.title}}</p>
          </div>
          <h2 class="uppercase">
            {{ data?.days.length | number : '2.0' }} {{this.localizationContent?.days}} /
            {{ data?.days.length - 1 | number : '2.0' }} {{this.localizationContent?.nights}}
          </h2>
          <div *ngIf="this.countries.length !== 0" class="flex flex-row mb-2">
            <div *ngFor="let country of this.countries">
              <p class="pe-3 font-light">{{ country }}</p>
            </div>
          </div>
        </div>
        <!-- Client Info -->
        <div *ngIf="!this.data?.viewSettings.isCustomerInformationChecked && this.data?.tour?.customer"
             class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white space-y-[20px]">
          <div class="flex flex-row justify-between">
            <h2>{{this.localizationContent?.client_tour_information}}</h2>
            <div>
              <lucide-icon
                class="client-header-icon flex"
                name="circle-user"></lucide-icon>
            </div>
          </div>

          <div class="grid  md:grid-cols-2 grid-cols-1">
            <div>
              <div class="flex flex-row gap-2">
                <p class="text-[#444444]">{{this.localizationContent?.name}}: </p>
                <p
                  class="text-[#444444]">{{ this.data.tour.customer.first_name + " " + this.data.tour.customer.last_name }}</p>
              </div>
              <div class="flex flex-row gap-2">
                <p class="text-[#444444]">{{this.localizationContent?.email}}: </p>
                <p class="text-[#444444]">{{ this.data.tour.customer?.email ? this.data.tour.customer?.email : "-" }}</p>
              </div>
              <div class="flex flex-row gap-2">
                <p class="text-[#444444]">{{this.localizationContent?.country}}: </p>
                <img loading="lazy" height="20px" width="20px"
                     [src]="this.findCountryFlagImage(this.data?.tour.customer.country.code)"
                     alt="country">
                <p class="text-[#444444]">{{ this.data.tour.customer.country.name }}</p>
              </div>
            </div>
            <div>
              <div class="flex flex-row gap-2" *ngIf="!this.data.tour.isDatesOptional">
                <p class="text-[#444444]">{{this.localizationContent?.dates}}: </p>
                <p
                  class="text-[#444444]">{{ this.customizeDate(this.data.tour.startDate, 'Do MMM, YYYY') + " - " + this.customizeDate(this.data.tour.endDate, 'Do MMM, YYYY') }}</p>
              </div>
              <div class="flex flex-row gap-2">
                <p class="text-[#444444]">{{this.localizationContent?.number_of_pax}}: </p>
                <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.adults !== 0">{{ this.data?.tour?.pax.adults | number : '2.0' }} <span
                  class="ml-0.5 text-[12px]">{{this.localizationContent?.adults}}</span></p>
                <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.children !== 0">{{ this.data?.tour?.pax.children | number : '2.0' }} <span
                  class="ml-0.5 text-[12px]">{{this.localizationContent?.children}}</span></p>
                <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.infants !== 0">{{ this.data?.tour?.pax.infants | number : '2.0' }} <span
                  class="ml-0.5 text-[12px]">{{this.localizationContent?.infant}}</span></p>

              </div>
            </div>
          </div>
        </div>
        <!-- Itinerary Overview -->
        <div *ngIf="this.data?.featured?.description"
          class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white space-y-[20px]">
          <h2>{{this.localizationContent?.overview}}</h2>
          <p class="text-[#444444]" [innerHTML]="this.data?.featured?.description"></p>
        </div>

        <div class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white space-y-[20px]">
          <div class="flex flex-row justify-between">
            <h2>{{this.localizationContent?.summary}}</h2>
            <div>
              <lucide-icon
                class="client-header-icon flex"
                name="binoculars"></lucide-icon>
            </div>
          </div>
          <div class="overflow-x-auto">
          <table class="min-w-full text-left border-separate border-spacing-y-2">
            <thead>
            <tr class="text-[#202A49] md:text-xl text-base font-semibold bg-[#F6F6F6]">
              <th class="px-2 py-2 min-w-[80px]">{{this.localizationContent?.day}}</th>
              <th class="px-2 py-2  min-w-[120px]">{{this.localizationContent?.date}}</th>
              <th class="px-2 py-2  min-w-[120px]">{{this.localizationContent?.accommodation}}</th>
              <th class="px-2 py-2  min-w-[110px]">{{this.localizationContent?.destination}}</th>
              <th class="px-2 py-2  min-w-[200px]">{{this.localizationContent?.rooms}}</th>
            </tr>
            </thead>
            <tbody class="md:text-xl text-base text-[#202A49]">
            <tr *ngFor="let day of data?.days; let i = index" class="bg-white shadow-sm rounded-md">
              <td class="px-2 py-2  break-words whitespace-normal min-w-[80px]">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</td>
              <td class="px-2 py-2  break-words whitespace-normal min-w-[120px]">{{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "-" }}</td>
              <ng-container *ngIf="!day?.isLeisureDay">
                <ng-container *ngIf="(!this.data?.viewSettings?.isDepartureChecked ||
                    i !== this.data?.days.length - 1) else altDepartureRow;">
                  <ng-container *ngIf="this.getAccommodationPerDate(day.date, this.data.accommodation).length !== 0 else altAcc">
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[120px]">{{this.getAccommodationPerDate(day.date, this.data.accommodation)[0].name}}</td>
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[110px]">{{day.destination ? this.displayTitle(day?.destination?.titles, this.data.tour.language) : "-" }}</td>
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[200px]">
                      <ng-container *ngIf="getAccommodationPerDate(day.date, data.accommodation)[0]?.rooms?.length > 0; else noRooms">
                        <div *ngFor="let room of this.getAccommodationPerDate(day.date, this.data.accommodation)[0]?.rooms; let i = index">
                            <span>
                              {{
                                (room.noOfRooms | number : '2.0') + ' x ' + (room?.roomCategory ? (room?.roomCategory | titlecase) : "") + " " +
                                (room?.roomType | titlecase) +
                                ' (' +
                                room?.mealType +
                                ')'
                              }}
                            </span>
                        </div>
                      </ng-container>
                      <ng-template #noRooms>
                        <span> - </span>
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-template #altAcc>
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[120px]"> - </td>
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[110px]">{{day.destination ? this.displayTitle(day?.destination?.titles, this.data.tour.language) : "-" }}</td>
                    <td class="px-2 py-2  break-words whitespace-normal min-w-[200px]"> - </td>
                  </ng-template>
                </ng-container>
                <ng-template #altDepartureRow>
                  <td colspan="3" class="px-2 py-2  break-words whitespace-normal">{{this.localizationContent?.departure}}</td>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="day?.isLeisureDay">
                <td colspan="3" class="px-2 py-2  break-words whitespace-normal">{{this.localizationContent?.leisure_day}}</td>
              </ng-container>
            </tr>
            </tbody>
          </table>
          </div>
        </div>

        <div *ngIf="this.data?.viewSettings?.isDisplayMapTopsideChecked" class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white">
          <div class="mb-[30px]">
            <h2>{{this.localizationContent?.map}}</h2>
          </div>
          <div class="flex justify-center">
            <img loading="lazy"
              class="rounded-[10px] object-contain h-auto md:h-[600px] w-auto"
              [src]="this.image"
              alt="map"/>
          </div>
        </div>
        <!-- Destinations -->
        <div
          *ngIf="this.citiesByCountry.length !== 0"
          class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white font-normal space-y-[15px]">
          <h2>{{this.localizationContent?.destinations}}</h2>
          <div *ngFor="let data of this.citiesByCountry">
            <div class="flex flex-col space-y-[20px]">
              <div class="flex flex-col lg:flex-row lg:items-center">
                <h3
                  style="font-weight: 400 !important"
                  class="text-[#454545] mr-10">
                  {{ data.country }}
                </h3>
                <div class="flex flex-col">
                  <div class="flex flex-wrap">
                    <div *ngFor="let city of data.cities; let i = index">
                      <p class="custom-countries-font-size text-[#666666] pe-2">
                        {{ city }}
                        <span *ngIf="i < data.cities.length - 1">, </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!this.data?.viewSettings?.isThumbnailChecked" class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white font-normal space-y-[15px]">
          <div class="flex flex-row justify-between">
            <h2 class="flex w-full">{{this.localizationContent?.tour_days}}</h2>
            <div class="flex flex-row gap-5 justify-end items-center w-full">
              <button (click)="goTourPrev()"
                      class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
                <lucide-icon name="arrow-left"></lucide-icon>
              </button>

              <button (click)="goTourNext()"
                      class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
                <lucide-icon name="arrow-right"></lucide-icon>
              </button>
            </div>
          </div>
          <div>
            <swiper-container
              #swiperTourDayRef
              class="swiper-tour-days"
              space-between="18"
              breakpoints='{
              "320":  { "slidesPerView": 1 },
              "640":  { "slidesPerView": 3 },
              "1024": { "slidesPerView": 4 }
            }'
              pagination="true" allow-touch-move="false" simulate-touch="false"
              speed="250"
              loop="false">
              <swiper-slide
                class="mb-8"
                *ngFor="let day of data.days; let i =index ">
                <div *ngIf="day.destination"
                     (click)="this.navigateToDay(i)"
                     [ngClass]="{
                            'thumbnail-clicked': selectedDayIndex === i,
                            'thumbnail-gradient ':      selectedDayIndex !== i
                                }"
                     class="md:max-w-xs w-full  rounded-2xl shadow-md p-6 text-center hover:cursor-pointer">
                    <ng-container  *ngIf="
                    (!this.data?.viewSettings?.isDepartureChecked || i !== this.data?.days.length - 1); else altDepture">
                      <ng-container *ngIf="!day?.isLeisureDay">
                        <img loading="lazy"
                          [src]="day?.featuredDestination?.image ? day?.featuredDestination?.image : placeholderPath "
                          [alt]="day?.featuredDestination?.name"
                          class="mx-auto h-24 w-24 rounded-full object-cover"
                        />
                        <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                        <p class="mt-1 ">{{
                            this.displayTitle(
                              day?.destination?.titles,
                              this.data.tour.language
                            )
                          }}
                        </p>
                      </ng-container>
                      <ng-container *ngIf="day?.isLeisureDay">
                        <img loading="lazy"
                             src="./assets/img/leisure_day.jpg"
                             [alt]="'Leisure Day'"
                             class="mx-auto h-24 w-24 rounded-full object-cover"
                        />
                        <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                        <p class="mt-1 text-gray-500">
                          {{this.localizationContent?.leisure_day}}
                        </p>
                      </ng-container>
                    </ng-container>
                    <ng-template #altDepture>
                      <img loading="lazy"
                           src="./assets/img/departure.jpg"
                           [alt]="'depatuure'"
                           class="mx-auto h-24 w-24 rounded-full object-cover"
                      />
                      <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1 text-gray-500">
                        {{this.localizationContent?.departure}}
                      </p>
                    </ng-template>
                </div>
                <div *ngIf="!day.destination" (click)="this.navigateToDay(i)"
                     [ngClass]="{
                            'thumbnail-clicked': selectedDayIndex === i,
                            'thumbnail-gradient ':      selectedDayIndex !== i
                                }"
                     class="max-w-xs  rounded-2xl shadow-md p-6 text-center hover:cursor-pointer">
                  <ng-container  *ngIf="
                    (!this.data?.viewSettings?.isDepartureChecked || i !== this.data?.days.length - 1); else altDepture">
                    <ng-container *ngIf="!day?.isLeisureDay">
                      <div
                        class="mx-auto h-24 w-24 rounded-full bg-gray-500">
                      </div>
                      <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1 h-8 ">
                      </p>
                    </ng-container>
                    <ng-container *ngIf="day?.isLeisureDay">
                      <img loading="lazy"
                           src="./assets/img/leisure_day.jpg"
                           [alt]="'Leisure Day'"
                           class="mx-auto h-24 w-24 rounded-full object-cover"
                      />
                      <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1 text-gray-500">
                        {{this.localizationContent?.leisure_day}}
                      </p>
                    </ng-container>
                  </ng-container>
                  <ng-template #altDepture>
                    <img loading="lazy"
                         src="./assets/img/departure.jpg"
                         [alt]="'depatuure'"
                         class="mx-auto h-24 w-24 rounded-full object-cover"
                    />
                    <h3 class="mt-4 text-xl">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                    <p class="mt-1 text-gray-500 h-8" *ngIf="!this.data?.viewSettings?.isDepartureChecked">
                    </p>
                    <p class="mt-1 text-gray-500" *ngIf="this.data?.viewSettings?.isDepartureChecked">
                      {{this.localizationContent?.departure}}
                    </p>
                  </ng-template>
                </div>
              </swiper-slide>
            </swiper-container>
          </div>
        </div>

        <!-- Itineraries -->
        <div
          class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white font-normal space-y-[40px]"
          *ngFor="let day of data?.days; let i = index" [id]="'day-' + i">
          <div
            *ngIf="
                (!this.data?.viewSettings?.isDepartureChecked ||
                  i !== this.data?.days.length - 1);
              else isDepartureBlock
            ">
            <ng-container *ngIf="!day.isMerged; else altMerge">
              <div class="mb-8">
                <div class="md:block hidden">
                  <div class="flex justify-between">
                    <div class="flex flex-row">
                      <div
                        class="mr-0 mb-5 md:mr-10 md:mb-0 items-start md:items-center">
                        <h1>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h1>
                      </div>
                      <div class="flex flex-col items-start justify-center leading-7 ">
                        <span *ngIf="day.destination && !day?.isLeisureDay"  class="text-[#454545] text-[2rem] font-semibold"
                              [ngClass]="this.data.tour.isDatesOptional ? 'mt-5': 'mt-0'">
                          {{
                            this.displayTitle(
                              day?.destination?.titles,
                              this.data.tour.language
                            )
                          }}
                        </span>
                        <span *ngIf="day?.isLeisureDay"  class="text-[#454545] text-[2rem] font-semibold"
                              [ngClass]="this.data.tour.isDatesOptional ? 'mt-5': 'mt-0'">
                          {{this.localizationContent?.leisure_day}}
                        </span>
                        <span *ngIf="!this.data.tour.isDatesOptional" class="text-[#969696] text-[1.25rem] font-medium">
                           {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="block md:hidden">
                  <div
                    class="mr-0 mb-5 md:mr-10 md:mb-0 items-start md:items-center">
                    <div class="flex flex-row">
                      <div>
                        <h1>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h1>
                      </div>

                      <div class="flex items-center">
                        <span class="text-[13px] ml-2 mt-2"> {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!day?.isLeisureDay" class="flex items-start md:items-center">
                    <h3 *ngIf="day.destination"  class="text-[#454545] font-semibold">
                      {{
                        this.displayTitle(
                          day?.destination?.titles,
                          this.data.tour.language
                        )
                      }}
                    </h3>
                  </div>
                  <div *ngIf="day?.isLeisureDay" class="flex items-start md:items-center">
                    <h3  class="text-[#454545] font-semibold">
                      {{this.localizationContent?.leisure_day}}
                    </h3>
                  </div>
                </div>
              </div>
              <div  class="grid grid-cols-12 gap-8">
                <div *ngIf="day.destination && !day?.isLeisureDay" class="col-span-12">
                  <div
                    *ngIf="day?.featuredDestination?.image"
                    class="relative w-full mb-6 rounded-[10px] overflow-hidden h-56 md:h-[35rem]"
                  >
                    <img
                      loading="lazy"
                      [src]="day?.featuredDestination?.image"
                      [alt]="day?.destination?.city"
                      class="w-full h-full object-cover"
                      [style.object-position]="getImageObjectPosition(day?.featuredDestination?.imagePosition)"
                    />
                  </div>
                  <p class="text-[#444444] text-justify">
                    {{ day?.featuredDestination?.body }}
                  </p>
                </div>
              </div>
            </ng-container>
            <ng-template #altMerge>
              <div class="mb-8">
                <div class="md:block hidden">
                  <div class="flex justify-between">
                    <div class="flex flex-row">
                      <div
                        class="mr-0 mb-5 md:mr-10 md:mb-0 items-start md:items-center">
                        <h1>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h1>
                      </div>
                      <div class="flex flex-col items-start justify-center leading-7 ">
                        <div *ngIf="!day?.isLeisureDay" class="flex items-start md:items-center">
                          <h3 *ngIf="day.destination"  class="text-[#454545] font-semibold">
                            {{
                              this.displayTitle(
                                day?.destination?.titles,
                                this.data.tour.language
                              )
                            }}
                          </h3>
                        </div>
                        <span *ngIf="day?.isLeisureDay"  class="text-[#454545] text-[2rem] font-semibold">
                          {{this.localizationContent?.leisure_day}}
                        </span>
                        <span class="text-[#969696] text-[1.25rem] font-medium">
                           {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="block md:hidden">
                  <div
                    class="mr-0 mb-5 md:mr-10 md:mb-0 items-start md:items-center">
                    <div class="flex flex-row">
                      <div>
                        <h1>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h1>
                      </div>

                      <div class="flex items-center">
                        <span class="text-[13px] ml-2 mt-2"> {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="day?.isLeisureDay" class="flex items-start md:items-center">
                    <h3  class="text-[#454545] font-semibold">
                      {{this.localizationContent?.leisure_day}}
                    </h3>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <ng-template #isDepartureBlock>
            <div class="hidden md:block">
              <div class="flex flex-row items-center justify-between">
                <div class="flex flex-row items-center">
                  <div class="mr-0 mb-10 md:mr-10 md:mb-0" [id]="'day-' + i">
                    <h1>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h1>
                  </div>
                  <div class="flex flex-col items-start justify-center leading-7">
                    <span class="text-[#454545] text-[2rem] font-semibold">{{this.localizationContent?.departure}}</span>
                    <span class="text-[#969696] text-[1.25rem] font-medium">
                        {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                      </span>
                  </div>
                </div>
                <div>
                  <lucide-icon
                    class="departure-icon flex"
                    name="plane-takeoff"></lucide-icon>
                </div>
              </div>
            </div>
            <div class="block md:hidden">
              <div class="flex flex-col mb-10">
                <div class="flex flex-row">
                  <div>
                    <h2>{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h2>
                  </div>

                  <div class="flex items-center">
                    <span class="text-[13px] ml-2 mt-2"> {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}</span>
                  </div>
                </div>
                <div class="flex flex-row items-center justify-between">
                  <div>
                    <h3 class="text-[#454545]">{{this.localizationContent?.departure}}</h3>
                  </div>
                  <div>
                    <lucide-icon
                      class="departure-icon-mobile flex"
                      name="plane-takeoff"></lucide-icon>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- Experience md screens greater -->
          <div
            class="space-y-[20px] hidden lg:block"
            *ngIf="
              data.experiences[i]?.experiencesPerDay[0]?.experience !== undefined && data.experiences[i]?.experiencesPerDay.length !== 0 && !day?.isLeisureDay
            ">
            <h2>{{this.localizationContent?.experiences}}</h2>
            <div *ngIf="data.experiences[i].experiencesPerDay.length > 1 else altExpStructure" class="grid grid-cols-3 gap-5">
              <div *ngFor="let exp of data.experiences[i].experiencesPerDay">
                <div class="relative w-full mb-6" *ngIf="exp?.featuredExperience?.image">
                  <img loading="lazy"
                    *ngIf="exp?.featuredExperience?.image"
                    class="object-cover rounded-t-xl h-[19rem] w-full"
                    [src]="exp?.featuredExperience?.image"
                    [style.object-position]="getImageObjectPosition(exp?.featuredExperience?.imagePosition)"
                    alt="Featured experience image"
                  />
                  <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                    <nz-icon  nz-tooltip
                              nzTooltipPlacement = 'left'
                              [nzTooltipArrowPointAtCenter]="true"
                              [nzTooltipTitle]="exp?.notes"
                              [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                              nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                    </nz-icon>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                      {{'Included'}}
                    </span>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                      {{'Excluded'}}
                    </span>
                  </div>
                </div>
                <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                  <h5 class="my-3">
                    {{
                      exp?.customTitle
                    }}
                  </h5>
                  <ng-container *ngIf="exp?.customUrl !== ''">
                    <a [href]="exp?.customUrl" target="_blank"
                       rel="noopener noreferrer">
                      <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                    </a>
                  </ng-container>
              </div>
                <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                  <h5 class="my-3">
                    {{
                      this.displayTitle(
                        exp.experience.titles,
                        this.data.tour.language
                      )
                    }}
                  </h5>
                  <ng-container *ngIf="exp?.customUrl !== ''">
                    <a [href]="exp?.customUrl" target="_blank"
                       rel="noopener noreferrer">
                      <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                    </a>
                  </ng-container>
                </div>
                <div>
                  <div
                    class="text-[#444444] truncate-lines"
                    [innerHTML]="
                      exp?.featuredExperience?.body
                    "></div>
                  <div
                    *ngIf="
                      !isStringLengthLessThanLimit(
                        exp?.featuredExperience?.body || '',
                        limit.lScreen
                      )
                    ">
                    <span
                      class="text-[#1278BA] cursor-pointer"
                      (click)="
                        this.viewContent(
                          exp?.featuredExperience?.body,
                          this.displayTitle(
                            exp.experience.titles,
                            this.data.tour.language
                          )
                        )
                      ">
                      {{this.localizationContent?.see_more}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #altExpStructure>
            <div class="grid grid-cols-12 gap-5" *ngFor="let exp of data.experiences[i].experiencesPerDay">
              <div class="col-span-4">
                <div class="relative mb-6" *ngIf="exp?.featuredExperience?.image">
                  <img loading="lazy"
                       *ngIf="exp?.featuredExperience?.image"
                       class="object-cover rounded-xl h-[19rem] w-full"
                       [src]="exp?.featuredExperience?.image"
                       [style.object-position]="getImageObjectPosition(exp?.featuredExperience?.imagePosition)"
                       alt="Featured experience image"
                  />
                  <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                    <nz-icon  nz-tooltip
                              nzTooltipPlacement = 'left'
                              [nzTooltipArrowPointAtCenter]="true"
                              [nzTooltipTitle]="exp?.notes"
                              [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                              nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                    </nz-icon>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                      {{'Included'}}
                    </span>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                      {{'Excluded'}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-span-8">
                <div>

                  <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                    <h5 class="my-3">
                      <h5 *ngIf="exp?.isCustomTitle" class="my-3">
                        {{
                          exp?.customTitle
                        }}
                      </h5>
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>
                  <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                    <h5 class="my-3">
                      {{
                        this.displayTitle(
                          exp.experience.titles,
                          this.data.tour.language
                        )
                      }}
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>
                  <div>
                    <div
                      class="text-[#444444] truncate-lines"
                      [innerHTML]="
                      exp?.featuredExperience?.body
                    "></div>
                    <div
                      *ngIf="
                      !isStringLengthLessThanLimit(
                        exp?.featuredExperience?.body || '',
                        limit.lScreen
                      )
                    ">
                    <span
                      class="text-[#1278BA] cursor-pointer"
                      (click)="
                        this.viewContent(
                          exp?.featuredExperience?.body,
                          this.displayTitle(
                            exp.experience.titles,
                            this.data.tour.language
                          )
                        )
                      ">
                      {{this.localizationContent?.see_more}}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </ng-template>
          </div>
          <!-- Experience md screens lesser -->
          <div
            class="space-y-[20px] lg:hidden md:block"
            *ngIf="
              data.experiences[i]?.experiencesPerDay[0]?.experience !== undefined && data.experiences[i]?.experiencesPerDay.length !== 0 && !day?.isLeisureDay
            ">
            <h3>{{this.localizationContent?.experiences}}</h3>
            <div>
              <swiper-container class="swiper-exp"
                space-between="25"
                slides-per-view="auto"
                pagination="true"
                speed="250"
                loop="false">
                <swiper-slide
                  class="mb-6"
                  *ngFor="let exp of data.experiences[i].experiencesPerDay">
                  <div>
                    <div class="relative w-full mb-6" *ngIf="exp?.featuredExperience?.image">
                      <img loading="lazy" *ngIf="exp?.featuredExperience?.image"
                           class="object-cover rounded-xl h-[14.438rem] md:h-60 w-full"
                           [src]="exp?.featuredExperience?.image"
                           [style.object-position]="getImageObjectPosition(exp?.featuredExperience?.imagePosition)"
                           alt=""/>
                      <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                        <nz-icon  nz-tooltip
                                  nzTooltipPlacement = 'left'
                                  [nzTooltipArrowPointAtCenter]="true"
                                  [nzTooltipTitle]="exp?.notes"
                                  [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                                  nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                        </nz-icon>
                      </div>
                      <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                           class="absolute bottom-4 right-4 z-10">
                        <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                          {{'Included'}}
                        </span>
                      </div>
                      <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                           class="absolute bottom-4 right-4 z-10">
                        <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                          {{'Excluded'}}
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                      <h4 class="my-3">
                          {{
                            exp?.customTitle
                          }}
                      </h4>
                      <ng-container *ngIf="exp?.customUrl !== ''">
                        <a [href]="exp?.customUrl" target="_blank"
                           rel="noopener noreferrer">
                          <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                        </a>
                      </ng-container>
                    </div>
                    <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                      <h4 class="my-3">
                          {{
                            this.displayTitle(
                              exp.experience.titles,
                              this.data.tour.language
                            )
                          }}
                      </h4>
                      <ng-container *ngIf="exp?.customUrl !== ''">
                        <a [href]="exp?.customUrl" target="_blank"
                           rel="noopener noreferrer">
                          <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                        </a>
                      </ng-container>
                    </div>
                    <div>
                      <div
                        class="text-xl text-[#444444] truncate-lines"
                        [innerHTML]="
                          exp?.featuredExperience?.body
                        "></div>
                      <div
                        *ngIf="
                          !isStringLengthLessThanLimit(
                            exp?.featuredExperience?.body || '',
                            limit.mdScreen
                          )
                        ">
                        <span
                          class="text-xl text-[#1278BA] cursor-pointer"
                          (click)="
                            this.viewContent(
                              exp?.featuredExperience?.body,
                              this.displayTitle(
                                exp.experience.titles,
                                this.data.tour.language
                              )
                            )
                          ">
                          {{this.localizationContent?.see_more}}
                        </span>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper-container>
            </div>
          </div>

          <!-- Accommodation -->
          <div
            *ngIf="getAccommodationPerDate(day.date, this.data.accommodation).length !== 0 && !day?.isLeisureDay"
            class="col-span-12 lg:col-span-4 space-y-[20px]">
            <h2>{{this.localizationContent?.accommodation}}</h2>
            <div
              *ngFor="
                    let accommodation of getAccommodationPerDate(day.date,this.data.accommodation)
                  "
              class="grid grid-cols-12 md:gap-8  gap-5">
              <div class="md:col-span-4 col-span-12" *ngIf="!this.data?.viewSettings.isHotelImageChecked">
                <div class="relative w-full mb-6">
                  <img loading="lazy"
                       class="w-full h-[17.8rem] md:h-[18rem] object-cover rounded-[10px]"
                       [src]="accommodation?.photoUri || placeholderPath"
                       alt="accommodation"/>
                  <div *ngIf="!this.data?.viewSettings.isAccommodationNoteChecked && accommodation.notes !== ''" class="absolute top-2 right-2 z-10">
                    <nz-icon  nz-tooltip
                              nzTooltipPlacement ='left'
                              [nzTooltipArrowPointAtCenter]="true"
                              [nzTooltipTitle]="accommodation?.notes"
                              [nzTooltipOverlayStyle]="{
                                      'max-width': '400px',
                                      'min-width': '300px',
                                      'white-space': 'normal',
                                      'line-height': '1.5'
                                    }"
                              nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                    </nz-icon>
                  </div>
                </div>
              </div>
              <div class="md:col-span-6 col-span-12">
                <h4 class="text-[#444444] mt-6">{{ accommodation?.name }}</h4>
                <p
                *ngIf="!this.data?.viewSettings.isHotelRatingChecked"
                class="mb-3 font-medium text-primary">
                {{ accommodation?.rating }} {{this.localizationContent?.star}}
              </p>
                <div class="flex flex-col">
                  <ng-container *ngIf="!this.data?.viewSettings.isAccommodationRoomsChecked">
                  <div
                    *ngFor="let room of accommodation?.rooms; let i = index">
                    <div class="flex">
                      <div class="flex flex-row items-center">
                        <lucide-icon
                          class="accommodation-subheader-icon flex mr-1"
                          name="bed-double"></lucide-icon>
                        <p
                          class="space-x-[10px] text-[#444444] mr-1 font-light">
                          {{
                            (room.noOfRooms | number : '2.0') + ' x ' + (room?.roomCategory ? (room?.roomCategory | titlecase) : "") + " " +
                            (room?.roomType | titlecase) +
                            ' (' +
                            room?.mealType +
                            ')'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  </ng-container>
                  <ng-container *ngIf="!this.data?.viewSettings.isHotelDescriptionChecked">
                    <div class="my-3" *ngIf="accommodation?.hotelDescription">
                      <p>{{ accommodation?.hotelDescription }}</p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!this.data?.viewSettings.isHotelWebsiteChecked">
                    <div class="flex" *ngIf="accommodation?.websiteUri">
                      <a
                        class="text-blue-900 hover:no-underline hover:text-[#202A49] capitalize"
                        href="{{
                            accommodation?.websiteUri
                          }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.visit_website}}</a
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              day?.remarksTips && !this.data?.viewSettings?.isRemarksTipsChecked
            "
            class="space-y-[20px]">
            <h4>{{day?.remarksTitle ? day?.remarksTitle : "Day Highlights"}}</h4>
            <div>
              <p class="richtext-html-hyperlink" [innerHTML]="day?.remarksTips"></p>
            </div>
          </div>

          <div
            *ngIf="day.transport.length !== 0"
            class="space-y-[20px] hidden lg:block">
            <h2 class="mb-12">{{this.localizationContent?.transportation}}</h2>
            <app-transport-timeline class="preview-custom"  [transData]="day.transport" [viewType]="'web'" [data]="this.data">
            </app-transport-timeline>
          </div>
          <div
            *ngIf="day.transport.length !== 0"
            class="space-y-[40px] lg:hidden block">
            <h2 class="mb-12">{{this.localizationContent?.transportation}}</h2>
            <app-transport-timeline [transData]="day.transport" [viewType]="'mobile'" [data]="this.data">
            </app-transport-timeline>
          </div>
        </div>
        <div *ngIf="!this.data?.viewSettings.isDisplayMapTopsideChecked" class="px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white">
          <div class="mb-[30px]">
            <h2>{{this.localizationContent?.map}}</h2>
          </div>
          <div class="flex justify-center">
            <img loading="lazy"
              class="rounded-[10px] object-contain h-auto md:h-[600px] w-auto"
              [src]="this.image"
              alt="map"/>
          </div>
        </div>
        <div *ngIf="this.determineToShowCard()"
          class="gap-5 px-8 py-8 md:px-12 md:py-8 rounded-[20px] bg-white">
          <!-- Inclusion -->
          <div class="grid grid-cols-1 lg:grid-cols-2">
            <div *ngIf="data?.itinerary?.inclusions">
              <h2>{{this.localizationContent?.inclusion}}</h2>
              <div class="my-[30px] prose" [innerHTML]="data?.itinerary?.inclusions"></div>
            </div>
            <!-- Exclusion -->
            <div *ngIf="data?.itinerary?.exclusions">
              <h2>{{this.localizationContent?.exclusion}}</h2>
              <div class="my-[30px] prose" [innerHTML]="this.data?.itinerary?.exclusions"></div>
            </div>
          </div>
          <div class="grid grid-cols-1">
            <!-- Cancellation Policy changed to Terms & Conditions -->
            <div class="mt-[20px]" *ngIf="data?.itinerary?.policies">
              <h2>{{this.localizationContent?.terms_and_conditions}}</h2>
              <div class="mt-[30px] prose terms-inner-html-t1  truncate-lines-terms"
                   [innerHTML]="this.data?.itinerary?.policies"></div>
              <div class="mt-2"
                *ngIf="
                          !isStringLengthLessThanLimit(
                            this.data?.itinerary?.policies || '',
                            400
                          )
                        ">
                        <span
                          class="text-xl text-[#1278BA] cursor-pointer"
                          (click)="
                            this.viewContentInnerHtml(
                              this.data?.itinerary?.policies,
                             this.localizationContent?.terms_and_conditions
                            )
                          ">
                          {{this.localizationContent?.see_more}}
                        </span>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
        <!-- Tour Cost -->
        <div *ngIf="!this.data?.costSettings?.isDynamicPricing">
        <div
          *ngIf="
            this.data?.costing?.personCost !== 0 &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType !== 'custom' && this.isClientUrl
          "
          class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
          <div
            class="flex flex-col md:flex-row justify-between md:items-center">
            <div>
              <h3 class="hidden md:block text-[#454545]">{{ this.data?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}</h3>
              <h4
                style="font-weight: 800 !important"
                class="block md:hidden font-semibold text-[#454545] uppercase">
                {{this.data?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : 'Total Tour Cost'}}
              </h4>
            </div>
            <div class="flex md:flex-row flex-col gap-5">
            <div class="flex md:flex-col flex-row leading-4">
              <h2 style="font-weight: normal !important">
                {{ this.data?.tour?.currency }}
                <span class="font-semibold">
                  {{
                    (this.data?.costing?.viewType === 'person' ? this.data?.costing?.personCost : this.data?.costing?.grandTotal) |number:'1.2-2'
                  }}
                </span>
              </h2>
              <span
                class="custom-under-text">
              {{this.data?.costing?.viewType === 'person' ? this.localizationContent?.per_person : this.localizationContent?.total_tour_cost}}
              </span>
            </div>
            <div
              *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
              <button
                class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
              </button>
            </div>
            </div>
          </div>
          <nz-divider *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null"></nz-divider>
          <div
            *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null">
            <div
              class="flex flex-col md:flex-row justify-between md:items-center">
              <div>
                <h5 class="hidden md:block text-[#454545]">{{this.localizationContent.special_notes}}</h5>
                <h4
                  style="font-weight: 800 !important"
                  class="block md:hidden font-semibold text-[#454545] uppercase">
                  {{this.localizationContent.special_notes}}
                </h4>
              </div>
            </div>
            <div class="my-[14px] prose" [innerHTML]="data?.costing.pricingRemarks"></div>
          </div>
        </div>

        <div
          *ngIf="!this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType === 'custom' && (this.data?.costing?.costPerAdult !==0 || this.  data?.costing?.costPerInfant !==0 || this.data?.costing?.costPerChild) && this.isClientUrl"
          class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
          <div
            class="flex flex-col md:flex-row justify-between md:items-center">
            <div>
              <h3 class="hidden md:block text-[#454545]">{{this.localizationContent?.cost_per_person}}</h3>
              <h4
                style="font-weight: 800 !important"
                class="block md:hidden font-semibold text-[#454545] uppercase">
                {{this.localizationContent?.cost_per_person}}
              </h4>
            </div>
            <div class="flex flex-col md:flex-row gap-5">
              <div *ngIf="this.data?.costing?.costPerAdult !==0 && this.data?.costing?.costPerAdult !== null" class="flex md:flex-col flex-row leading-5">
                <span class="text-[17px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.costing?.costPerAdult |number:'1.2-2'
                    }}</span>
                </span>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_adult}}</span
                >
              </div>
              <div *ngIf="this.data?.costing?.costPerChild !==0  && this.data?.costing?.costPerChild !== null" class="flex md:flex-col flex-row leading-5">
                 <span class="text-[17px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.costing?.costPerChild |number:'1.2-2'
                    }}</span>
                 </span>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_child}}</span
                >
              </div>
              <div *ngIf="this.data?.costing?.costPerInfant !==0 && this.data?.costing?.costPerInfant !== null" class="flex md:flex-col flex-row leading-5">
                 <span class="text-[17px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.costing?.costPerInfant  |number:'1.2-2'
                    }}</span>
                 </span>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_infant}}</span
                >
              </div>
              <div
                *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
                <button
                  class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
                </button>
              </div>
            </div>
          </div>
          <nz-divider *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null"></nz-divider>
          <div
            *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null">
            <div
              class="flex flex-col md:flex-row justify-between md:items-center">
              <div>
                <h5 class="hidden md:block text-[#454545]">{{this.localizationContent.special_notes}}</h5>
                <h4
                  style="font-weight: 800 !important"
                  class="block md:hidden font-semibold text-[#454545] uppercase">
                  {{this.localizationContent.special_notes}}
                </h4>
              </div>
            </div>
            <div class="my-[14px] prose" [innerHTML]="data?.costing.pricingRemarks"></div>
          </div>
        </div>
        </div>
        <div *ngIf="this.data?.costSettings?.isDynamicPricing && !this.data?.viewSettings.isTourCostHidden">
          <div
            class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal space-y-[20px]">
            <div
              class="flex flex-col md:flex-row justify-between md:items-center">
              <div>
                <h2>{{this.localizationContent.seasonal_pricing}}</h2>
              </div>
            </div>
            <div>
              <table class="min-w-full text-left border-separate border-spacing-y-2 mb-8">
                <thead class="text-[#202A49] text-[11px] font-normal bg-[#F6F6F6]">
                <tr class="text-center">
                  <th
                    class="py-3 px-4 min-w-20"
                    *ngFor="let header of data?.costing?.dynamicPricing?.headers">
                    {{ header.name }}
                  </th>
                </tr>
                </thead>

                <tbody class="text-[11px] text-center text-[#202A49]">
                <tr
                  class="bg-white shadow-sm rounded-md"
                  *ngFor="let row of data?.costing?.dynamicPricing?.rows">
                  <td
                    class="py-3 px-4 min-w-20"
                    *ngFor="let cell of row; let i = index">
                    {{ getCellDisplay(i, cell) }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <nz-divider *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null"></nz-divider>
            <div
              *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null">
              <div
                class="flex flex-col md:flex-row justify-between md:items-center">
                <div>
                  <h5 class="hidden md:block text-[#454545]">{{this.localizationContent.special_notes}}</h5>
                  <h4
                    style="font-weight: 800 !important"
                    class="block md:hidden font-semibold text-[#454545] uppercase">
                    {{this.localizationContent.special_notes}}
                  </h4>
                </div>
              </div>
              <div class="my-[14px] prose" [innerHTML]="data?.costing.pricingRemarks"></div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!this.data?.viewSettings.isTourOperatorHidden">
          <div *ngIf="this.data?.tour?.type === 'B2C' && this.isClientUrl" class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
          <div class="flex flex-col justify-center">
                <div>
                  <h4 class="mb-8 flex justify-center">{{this.tourOperatorTitle}}</h4>
                  <div class="mb-4 flex flex-row justify-center items-center">
                    <div class="pr-5" *ngIf="this.data?.creator[0].profile">
                      <img
                        class="rounded-full object-cover w-24 h-24"
                        [src]="this.data?.creator[0].profile"
                        alt="profile"/>
                    </div>
                    <div class="flex flex-col">
                      <h4 class="font-medium">
                        {{ this.data?.creator[0].name }}
                      </h4>
                      <div class="flex flex-row my-3 items-center">
                        <lucide-icon
                          class="aboutus-subheader-icon flex"
                          name="at-sign"></lucide-icon>
                        <span class="ps-2 text-[#444444]">
                          <a
                            href="mailto:{{
                              this.data?.creator[0].email
                            }}?subject=Travsta Operator - {{
                              this.data?.creator[0].name
                            }}"
                          >{{ this.data?.creator[0].email }}</a
                          ></span
                        >
                      </div>
                      <div class="flex flex-row items-center">
                        <lucide-icon
                          class="aboutus-subheader-icon flex"
                          name="phone"></lucide-icon>
                        <span class="ps-2 text-[#444444]">

                          {{ this.data?.creator[0]?.dialCode || "" }} {{ this.data?.creator[0].mobile }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            <nz-divider></nz-divider>
            <div class="flex flex-col justify-center gap-5">
              <div class="flex justify-center">
                <img loading="lazy"
                     class="w-[21.75rem] h-[5.125rem] rounded-xl object-contain object-center"
                     [src]="this.organizationSetting?.logo"
                     alt="Company Logo"/>
              </div>
              <div class="flex justify-center">
                <h4 class="font-bold text-[#454545]">
                  {{ this.organizationSetting?.companyName }}
                </h4>
              </div>
              <div class="flex justify-center">
                <p class="text-justify custom-max-w-summary">
                  {{ this.organizationSetting?.companyDetails?.summary }}
                </p>
              </div>
              <div
                *ngIf="!this.data?.viewSettings.isWebsiteLinkChecked"
                class="flex justify-center">
                <button
                  class="px-16 py-4 border rounded-[1.25rem] border-black border-solid mb-7">
                  <span class="font-semibold text-lg text-[#202A49]">
                    <a
                      class="hover:no-underline hover:text-[#202A49] capitalize"
                      href="{{
                        this.organizationSetting?.companyDetails?.websiteLink
                      }}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >{{this.localizationContent?.visit_website}}</a
                    >
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        </ng-container>

        <!--        THIS SECTION IS FOR B2B-->
        <div *ngIf="!this.data?.costSettings?.isDynamicPricing">
        <div
          *ngIf="
            (this.data?.b2b?.costing?.personCost !== 0 || this.data?.b2b?.costing?.grandTotal !== 0)  &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType !=='custom' && !this.isClientUrl
          "
          class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
          <div
            class="flex flex-col md:flex-row justify-between md:items-center">
            <div>
              <h3 class="hidden md:block text-[#454545]">
                {{this.data?.b2b?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}
              </h3>
              <h4
                style="font-weight: 800 !important"
                class="block md:hidden font-semibold text-[#454545] uppercase">
                {{this.data?.b2b?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}
              </h4>
            </div>
            <div class="flex md:flex-row flex-col gap-2">
            <div class="flex md:flex-col flex-row leading-4">
              <h2 style="font-weight: normal !important">
                {{ this.data?.tour?.currency }}
                <span class="font-semibold">
                  {{
                    (this.data?.b2b.costing?.viewType === 'person' ? this.data?.b2b.costing?.personCost : this.data?.b2b.costing?.grandTotal) |number:'1.2-2'
                  }}
                </span>
              </h2>
              <span
                class="custom-under-text">
                {{this.data?.b2b.costing?.viewType === 'person' ? this.localizationContent?.per_person : this.localizationContent?.total_tour_cost}}
              </span>
            </div>
<!--              <div-->
<!--                *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.b2b?.paymentLink !=='' && this.data?.b2b?.paymentLink !==null">-->
<!--                <button-->
<!--                  class="payment-button">-->
<!--                    <span>-->
<!--                      <a-->
<!--                        href="{{ this.data?.b2b?.paymentLink }}"-->
<!--                        target="_blank"-->
<!--                        rel="noopener noreferrer"-->
<!--                      >{{this.localizationContent?.pay_now}}</a-->
<!--                      >-->
<!--                    </span>-->
<!--                </button>-->
<!--              </div>-->
            </div>
          </div>
        </div>

        <div
          *ngIf="!this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType ==='custom' && !this.isClientUrl"
          class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
          <div
            class="flex flex-col md:flex-row justify-between md:items-center">
            <div>
              <h3 class="hidden md:block text-[#454545]">{{this.localizationContent?.cost_per_person}}</h3>
              <h4
                style="font-weight: 800 !important"
                class="block md:hidden font-semibold text-[#454545] uppercase">
                {{this.localizationContent?.cost_per_person}}
              </h4>
            </div>
            <div class="flex flex-col md:flex-row gap-5">
              <div class="flex md:flex-col flex-row leading-5">
                <h2 style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.b2b?.costing?.costPerAdult | number:'1.2-2'
                    }}</span>
                </h2>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_adult}}</span
                >
              </div>
              <div class="flex md:flex-col flex-row leading-5">
                <h2 style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.b2b?.costing?.costPerChild |number:'1.2-2'
                    }}</span>
                </h2>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_child}}</span
                >
              </div>
              <div class="flex md:flex-col flex-row leading-5">
                <h2 style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.b2b?.costing?.costPerInfant  |number:'1.2-2'
                    }}</span>
                </h2>
                <span
                  class="custom-under-text"
                >{{this.localizationContent?.per_infant}}</span
                >
              </div>
<!--              <div-->
<!--                *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.b2b?.paymentLink !=='' && this.data?.b2b?.paymentLink !==null">-->
<!--                <button-->
<!--                  class="payment-button">-->
<!--                    <span>-->
<!--                      <a-->
<!--                        href="{{ this.data?.b2b?.paymentLink }}"-->
<!--                        target="_blank"-->
<!--                        rel="noopener noreferrer"-->
<!--                      >{{this.localizationContent?.pay_now}}</a-->
<!--                      >-->
<!--                    </span>-->
<!--                </button>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        </div>
        <ng-container *ngIf="!this.data?.viewSettings.isTourOperatorHidden">
          <div *ngIf="this.data?.tour?.type === 'B2B' && !this.isClientUrl" class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
            <div class="flex flex-col justify-center">
              <div class="flex flex-col justify-center gap-5">
                <div class="flex justify-center" *ngIf="this.data?.b2b?.customer?.logo">
                  <img loading="lazy"
                       class="w-[21.75rem] h-[5.125rem] rounded-xl object-contain object-center"
                       [src]="this.data?.b2b?.customer?.logo"
                       alt="Company Logo"/>
                </div>
                <div class="flex justify-center">
                  <h4 class="font-bold text-[#454545]">
                    {{ this.data?.b2b?.customer?.companyName }}
                  </h4>
                </div>
                <div class="flex justify-center">
                  <p class="text-justify custom-max-w-summary">
                    {{ this.data?.b2b?.customer?.summary }}
                  </p>
                </div>
                <div
                  *ngIf="!this.data?.viewSettings.isWebsiteLinkChecked && this.data?.b2b?.customer?.websiteLink !== '' && this.data?.b2b?.customer?.websiteLink !== null"
                  class="flex justify-center">
                  <button
                    class="px-16 py-4 border rounded-[1.25rem] border-black border-solid mb-7">
                  <span class="font-semibold text-lg text-[#202A49]">
                    <a
                      class="hover:no-underline hover:text-[#202A49] capitalize"
                      href="{{
                        this.data?.b2b?.customer?.websiteLink
                      }}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >{{this.localizationContent?.visit_website}}</a
                    >
                  </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- END OF B2B -->


        <div *ngIf="this.data?.tour?.type === 'B2B' && this.isClientUrl && !this.determineToShow()"
             class="px-8 rounded-[20px] bg-[#dedede]" style="margin-bottom: 20px !important;">
          <div class="w-full h-80 flex justify-center items-center">
            <p>Editable link allows the B2B travel agent to modify this section</p>
          </div>
        </div>

        <ng-container *ngIf="!this.data?.viewSettings.isTourOperatorHidden">
          <div *ngIf="this.data?.tour?.type  === 'B2B' && this.isClientUrl && this.determineToShow()" class="py-7 md:py-10 px-8 rounded-[20px] bg-white font-normal">
            <div class="flex flex-col justify-center">
              <div class="flex flex-col justify-center gap-5">
                <div class="flex justify-center" *ngIf="this.data?.b2b?.customer?.logo">
                  <img loading="lazy"
                       class="w-[21.75rem] h-[5.125rem] rounded-xl object-contain object-center"
                       [src]="this.data?.b2b?.customer?.logo"
                       alt="Company Logo"/>
                </div>
                <div class="flex justify-center">
                  <h4 class="font-bold text-[#454545]">
                    {{ this.data?.b2b?.customer?.companyName }}
                  </h4>
                </div>
                <div class="flex justify-center">
                  <p class="text-justify custom-max-w-summary">
                    {{ this.data?.b2b?.customer?.summary }}
                  </p>
                </div>
                <div
                  *ngIf="!this.data?.viewSettings.isWebsiteLinkChecked && this.data?.b2b?.customer?.websiteLink !== '' && this.data?.b2b?.customer?.websiteLink !== null"
                  class="flex justify-center">
                  <button
                    class="px-16 py-4 border rounded-[1.25rem] border-black border-solid mb-7">
                  <span class="font-semibold text-lg text-[#202A49]">
                    <a
                      class="hover:no-underline hover:text-[#202A49] capitalize"
                      href="{{
                        this.data?.b2b?.customer?.websiteLink
                      }}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >{{this.localizationContent?.visit_website}}</a
                    >
                  </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="container md:mt-10 mt-36">
      <div class="grid grid-cols-1">
        <div class="drop-shadow bottom-2 right-0 left-0 fixed z-50 w-full px-8 py-8 md:py-8 md:pb-0" *ngIf="this.data?.tour?.type  !== 'B2C' && !this.isClientUrl">
          <div class="py-5 px-10 bg-white text-center rounded-[10px]">
            <div
                 class="flex flex-col md:flex-row justify-center md:justify-between">
              <div class="flex justify-center items-end md:mb-0 mb-2">
                <h5>Agent Edit Panel</h5>
              </div>
              <div class="flex justify-center items-center" *ngIf="!this.isNotExpiredRealTime">
                <a><span class="text-[#6911D8] md:text-[1.25rem] text-[1rem]" (click)="this.addEditCustomerInformation(this.data)">Change Information</span></a>
              </div>
              <div class="flex justify-center items-center">
                <a><span class="text-[#6911D8] md:text-[1.25rem] text-[1rem]" (click)="this.generatePDF()">Download PDF</span></a>
              </div>
              <div class="flex justify-center items-center" *ngIf="this.data.isLinkExpirationEnabled">
                <span *ngIf="!this.isNotExpiredRealTime" class="text-[#6F6F6F] md:text-[1.25rem] text-[1rem]">Link Expires in {{this.timeLeft}}</span>
                <span *ngIf="this.isNotExpiredRealTime" class="text-[#6F6F6F] md:text-[1.25rem] text-[1rem]">Link Expired</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</nz-spin>
